export default __webpack_public_path__ + "static/media/bundleModalImg.cc55ac35.png";